
import { mapStores } from "pinia";
import { useUserStore } from "@/stores/userStore";
import { Options, Vue } from "vue-class-component";

@Options({
  name: "TestLoginView",
  computed: {
    ...mapStores(useUserStore),
  },
})
export default class CompleteAccountView extends Vue {
  email = "";
  password = "";

  userStore = useUserStore();

  async submitForm() {
    this.userStore.login({ email: this.email, password: this.password });
  }
}
